/**
 * Сравнение строк-источников «по файлу» (фича 038): имя файла, затем лист.
 *
 * Листы одной Excel-книги — отдельные документы с общим именем файла, поэтому
 * без листа строки разных листов при сортировке по файлу перемешиваются.
 * Лист учитывается всегда: у однолистовых файлов это ничего не меняет.
 */

interface SourceFileKey {
	fileName: string;
	sheetName?: string | null;
}

const LOCALE = "ru-RU";

export function compareSourceFile(a: SourceFileKey, b: SourceFileKey): number {
	const byFile = a.fileName.localeCompare(b.fileName, LOCALE);
	if (byFile !== 0) return byFile;
	return (a.sheetName ?? "").localeCompare(b.sheetName ?? "", LOCALE);
}
